import { render } from "./DetailBody.vue?vue&type=template&id=3f1b4d4f"
import script from "./DetailBody.vue?vue&type=script&lang=ts"
export * from "./DetailBody.vue?vue&type=script&lang=ts"
script.render = render

export default script